module.exports = __webpack_public_path__ + "img/pp_logo.3c0f5ab1.png";